<template>
  <div class="wrapper">
    <el-image class="brand-image" :src="url" fit="contain"></el-image>
  </div>
</template>

<script>
export default {
  props: {
    brand: Object,
  },

  computed: {
    /**
     * @returns {string}
     */
    url() {
      return this.brand.logo;
    }
  }
}
</script>

<style scoped>
.brand-image {
  width: 100px;
  height: 50px
}
</style>
